import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestionOptionsTableColumnNames, fetchAllQuestionOptions, createQuestionOptions, updateQuestionOptions, 
    deleteQuestionOptions, updateUserPreference} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";


const labels = [
  {
    id: 1,
    labelName: "OptionEn",
    fieldName: "text-box",
    name: "OptionEn",
    value: "OptionEn",
    required: true,
  },
  {
    id: 2,
    labelName: "OptionAr",
    fieldName: "text-box",
    name: "OptionAr",
    value: "OptionAr",
    required: true,
  },
  {
    id: 3,
    labelName: "Correct",
    fieldName: "check-box",
    name: "IsCorrect",
    value: "IsCorrect",
    required: false,
  }
]


function QuestionOptions () {
  const { questionId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const { Course, QuestionOptions, tableColumnNames, loading, module } = useSelector((state) => ({
    QuestionOptions: state.QuestionOptions.questionOptions,
    tableColumnNames: state.QuestionOptions.tableColumnNames,
    loading: state.QuestionOptions.loading,
    module: state.Module.module,
}));

  // Compute permission
  const permission = (() => {
      const moduleItem = module?.find(
          (m) => m.moduleId === 9 && m.modulePermission?.CanView
        );
        const pageItem = moduleItem?.pages?.find((p) => p.pageId === 8); // Roles Management = pageId: 2
        
        if (moduleItem && pageItem) {
            return {
                CanView:
                moduleItem.modulePermission.CanView && pageItem.permissions.CanView,
                CanAdd:
                moduleItem.modulePermission.CanAdd && pageItem.permissions.CanAdd,
                CanEdit:
          moduleItem.modulePermission.CanEdit && pageItem.permissions.CanEdit,
          CanDelete:
          moduleItem.modulePermission.CanDelete &&
          pageItem.permissions.CanDelete,
          CanActive:
          moduleItem.modulePermission.CanActive &&
          pageItem.permissions.CanActive,
        };
    }
    
    return {};
})();



  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (questionOptions, value) => {
    setSelectedRow(questionOptions);
    setIsAddOrEdit(value);
    setShow(true);
  };
  
  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    setSelectedRow((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  
  
  const onSubmitHandler = (e) => {
    e.preventDefault();


    const questionOptionsObj = {
      OptionEn: selectedRow.OptionEn,
      OptionAr: selectedRow.OptionAr,
      QuestionID: questionId,
      IsCorrect: selectedRow.IsCorrect
    };

    if (isAddOrEdit === "isEdit") {
        questionOptionsObj.ID = selectedRow?.ID;
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createQuestionOptions(questionOptionsObj)) :
      dispatch(updateQuestionOptions(questionOptionsObj));

    setShow(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchAllQuestionOptions({
          module: "QUESTIONOPTIONS"
        })
      );

      setModalOpen(false);
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteQuestionOptions({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };
  
  useEffect(() => {
    dispatch(fetchQuestionOptionsTableColumnNames({ module: "QUESTIONOPTIONS" }))
    dispatch(fetchAllQuestionOptions());

  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t('QuestionOptions')} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            {/* <CardHeader>
              <h4 className="card-title mb-0">Add, Edit & Remove</h4>
            </CardHeader> */}

            <CardBody>
              <div className="listjs-table" id="customerList">
                <Row className="g-4 mb-3">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    <CommonTable
                      data={QuestionOptions}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
      <AddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        title={isAddOrEdit === "isAdd" ? t("AddNewQuestionOptions") : t("EditQuestionOptions")}
        modalBody={
          <AddCommonForm2
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedRow={selectedRow}
            onChangeHandler={onChangeHandler}
          />
        }
      />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={
          selectedIds.length > 1
            ? `Are you sure you want to delete ${selectedIds.length} selected items?`
            : `Are you sure you want to delete this record?`
        }
      />
    </div>
  );
}

export default QuestionOptions;